export const ACCENT_COLORS = [
	"#4A7DE8", // electric blue
	"#E84B6A", // coral red
	"#3ED8C3", // mint teal
	"#A855F7", // soft violet
	"#F97316", // burnt orange
	"#F2C233", // sunflower yellow
	"#3DBE7A", // emerald green
	"#E83E8C", // fuchsia pink
	"#2BB8E8", // sky cyan
	"#E84530", // tomato red
];

export function accentForId(id: string): string {
	let hash = 0;
	for (let i = 0; i < id.length; i++) {
		hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
	}
	return ACCENT_COLORS[hash % ACCENT_COLORS.length] ?? "#4A7DE8";
}

export function accentGradient(accent: string): string {
	// gradient going from ~10% opacity to 02$ opacity wiht the accent color
	// hex values from transparency https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
	return `linear-gradient(to right, ${accent}1A, ${accent}05`
}
